/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const totalStyle = {
  textAlign: "center",
  background: "#ddeff3",
  fontWeight: "bold",
  textAlign: "right",
  paddingRight: 20,
};

const titleStyle = {
  textAlign: "right",
  paddingRight: 20,
  background: "#ddeff3",
  fontWeight: "bold",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    isTitle: true,
    index: "I",
    title: "Thu nhập từ đầu tư vốn",
    bg: true,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "1",
    spendId: 23,
    value: 0,
    value2: 0,
    title: "Tổng số cá nhân có thu nhập",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 24,
    value: 0,
    value2: 0,
    title: "Tổng thu nhập tính thuế",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "3",
    spendId: 25,
    value: 0,
    value2: 0,
    title: "Tổng số thuế thu nhập cá nhân (TNCN) đã khấu trừ",
    bg: false,
  },
  {
    id: uuidV4(),
    isTitle: true,
    index: "II",
    title: "Thu nhập từ chuyển nhượng chứng khoán",
    bg: true,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "1",
    spendId: 26,
    value: 0,
    value2: 0,
    title: "Tổng số cá nhân có thu nhập",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 27,
    value: 0,
    value2: 0,
    title: "Tổng giá trị chuyển nhượng chứng khoán",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "3",
    spendId: 28,
    value: 0,
    value2: 0,
    title: "Tổng số thuế TNCN đã khấu trừ",
  },
  {
    id: uuidV4(),
    isTitle: true,
    index: "III",
    title: "Thu nhập từ bản quyền, nhượng quyền thương mại",
    bg: true,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "1",
    spendId: 29,
    value: 0,
    value2: 0,
    title: "Tổng số cá nhân có thu nhập",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 30,
    value: 0,
    value2: 0,
    title: "Tổng thu nhập tính thuế",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "3",
    spendId: 31,
    value: 0,
    value2: 0,
    title: "Tổng số thuế TNCN đã khấu trừ",
  },
  {
    id: uuidV4(),
    isTitle: true,
    index: "IV",
    title: "Thu nhập từ trúng thưởng",
    bg: true,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "1",
    spendId: 32,
    value: 0,
    value2: 0,
    title: "Tổng số cá nhân thu nhập",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 33,
    value: 0,
    value2: 0,
    title: "Tổng thu nhập tính thuế",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "3",
    spendId: 34,
    value: 0,
    value2: 0,
    title: "Tổng số thuế TNCN đã khấu trừ",
  },
  {
    id: uuidV4(),
    isTitle: true,
    index: "V",
    title: "Doanh thu từ kinh doanh của cá nhân không cư trú",
    bg: true,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "1",
    spendId: 35,
    value: 0,
    value2: 0,
    title: "Tổng số cá nhân thu nhập",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 36,
    value: 0,
    value2: 0,
    title: "Tổng doanh thu tính thuế trả cho cá nhân",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "3",
    spendId: 37,
    value: 0,
    value2: 0,
    title: "Tổng số thuế TNCN đã khấu trừ",
  },
  {
    id: uuidV4(),
    isTitle: true,
    index: "VI",
    title: "Thu nhập từ chuyển nhượng vốn của cá nhân không cư trú",
    bg: true,
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "1",
    spendId: 38,
    value: 0,
    value2: 0,
    title: "Tổng số cá nhân thu nhập",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "2",
    spendId: 39,
    value: 0,
    value2: 0,
    title: "Tổng giá chuyển nhượng vốn",
  },
  {
    id: uuidV4(),
    isTitle: false,
    index: "3",
    spendId: 40,
    value: 0,
    value2: 0,
    title: "Tổng số thuế TNCN đã khấu trừ",
  },
];

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số phát sinh
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số lũy kế
              </Td>
            </tr>
            {data.map((item) => {
              if (item.isTitle) {
                return (
                  <tr key={item.id}>
                    <Td style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}>
                      {item.index}
                    </Td>
                    <Td
                      colSpan={4}
                      style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold" }}
                    >
                      {item.title}
                    </Td>
                  </tr>
                );
              }
              return (
                <tr key={item.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item?.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.index}
                  </Td>
                  <Td
                    style={{ textAlign: "left", background: item?.bg ? "#ddeff3" : "transparent" }}
                  >
                    {item.title}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: item?.bg ? "#ddeff3" : "transparent",
                    }}
                  >
                    [{item.spendId}]
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      background: item?.bg ? "#ddeff3" : "transparent",
                      paddingRight: item?.bg ? 20 : 8,
                    }}
                  >
                    {item?.bg ? (
                      item.value
                    ) : (
                      <InputTable
                        name="value"
                        id={item.id}
                        value={item.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      background: item?.bg ? "#ddeff3" : "transparent",
                      paddingRight: item?.bg ? 20 : 8,
                    }}
                  >
                    {item?.bg ? (
                      item.value2
                    ) : (
                      <InputTable
                        name="value2"
                        id={item.id}
                        value={item.value2}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { id, onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
